/**
 * `transition`
 *
 * An object specifying the transition effects to apply on the navigation chips
 * during their animation sequences.
 */
export const transition = {
  duration: 0.6,
} as const;
